/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const tradePartnersSlice = createSlice({
    name: 'tradePartners',
    initialState: initialState,
    reducers: {
        setTradePartnersData: (state, action) => {
            return action.payload;
        },
        resetTradePartnersData: () => {
            return initialState;
        },
    },
});

export const { setTradePartnersData, resetTradePartnersData } = tradePartnersSlice.actions;
export default tradePartnersSlice.reducer;
